import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { BOOK_IMAGE, PAYMENT_URL, offerIncludes } from '../data/landing';
export function OfferSection() {
  const [open, setOpen] = useState(false);
  const reduce = useReducedMotion();
  return <section id="oferta" className="scroll-mt-16 bg-ink px-4 pb-10 md:px-6 md:pb-16 lg:pb-20" data-id="element-113" data-mp="idi2kfcll801">
      <div className="mx-auto grid max-w-6xl items-center gap-4 rounded-3xl bg-parchment px-5 py-6 text-umber md:gap-10 md:rounded-[2rem] md:px-12 md:py-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16 lg:px-16 lg:py-16" data-id="element-114" data-mp="mejtm8wd2dqx">
        <img src={BOOK_IMAGE} alt="El Libro del Despertar, Volumen 1" className="mx-auto w-full max-w-[160px] mix-blend-multiply md:max-w-[260px] lg:max-w-[320px]" data-id="element-115" data-mp="wdj3tvwryhg1" />

        <div data-id="element-116" data-mp="2t7mbij5439dp">
          <p className="font-serif text-lg italic text-umber/70 md:text-xl" data-id="element-117" data-mp="2y44b74ll4hj6">
            Tu recorrido comienza aquí
          </p>
          <h2 className="mt-1 font-display text-2xl text-umber md:mt-2 md:text-3xl lg:text-4xl" data-id="element-118" data-mp="12ojzklxzckqi">
            El Libro del Despertar
          </h2>
          <p className="mt-2 text-[15px] text-umber/75 md:mt-3 md:text-base" data-id="element-119" data-mp="xupaf2zlvdk1">
            Tu acceso al libro digital y tres bonos complementarios.
          </p>

          <div className="mt-4 flex items-baseline gap-3 border-y border-umber/15 py-3 md:mt-8 md:py-6" data-id="element-120" data-mp="oxeuv5fr929b">
            <span className="text-xs font-semibold uppercase tracking-[0.15em] text-umber/70 md:text-sm" data-id="element-121" data-mp="1ll2yyjizeu9v">
              Solo
            </span>
            <span className="font-display text-5xl leading-none text-umber md:text-6xl" data-id="element-122" data-mp="1cloatqqaevsj">15</span>
            <span className="font-display text-xl text-umber md:text-2xl" data-id="element-123" data-mp="17mlj17zbim2i">USD</span>
          </div>

          <div className="mt-4 rounded-2xl border border-umber/15 md:mt-8" data-id="element-124" data-mp="16j6yjef6r7c">
            <h3 data-id="element-125" data-mp="14g7l8rdnlpy">
              <button type="button" aria-expanded={open} aria-controls="offer-includes" onClick={() => setOpen(o => !o)} className="flex w-full items-center justify-between gap-3 rounded-2xl px-4 py-3 text-left transition-colors duration-150 hover:bg-umber/5 focus:outline-none focus-visible:ring-2 focus-visible:ring-umber" data-id="element-126" data-mp="3scu2k00nuzra">
                <span className="text-xs font-semibold uppercase tracking-[0.15em] text-umber md:text-sm" data-id="element-127" data-mp="3ktung6k8fudq">
                  ¿Qué recibes?
                </span>
                <span className="flex items-center gap-2 text-xs text-umber/70" data-id="element-128" data-mp="3owr8s515q4ld">
                  {open ? 'Ocultar' : 'Ver 4 elementos'}
                  <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} data-id="element-129" data-mp="3fuhz1hdpqf91" />
                </span>
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-130" data-mp="365gjttezs1w4">
              {open && <motion.div id="offer-includes" initial={reduce ? false : {
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={reduce ? {
              opacity: 0
            } : {
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-131" data-mp="3622jsrtsw4ru">
                  <ul className="space-y-2 border-t border-umber/10 px-4 pb-4 pt-3 md:space-y-3" data-id="element-132" data-mp="2dk1g7rzi6orv">
                    {offerIncludes.map(item => <li key={item} className="flex items-start gap-3 text-[15px] text-umber md:text-base" data-id="element-133" data-mp="2midemg6m2quv">
                        <CheckIcon aria-hidden="true" className="mt-1 h-4 w-4 shrink-0 text-umber" data-id="element-134" data-mp="2igic58cy27fi" />
                        {item}
                      </li>)}
                  </ul>
                </motion.div>}
            </AnimatePresence>
          </div>

          <p className="mt-4 text-sm text-umber/75 md:mt-6" data-id="element-135" data-mp="2rhg9j7svngp4">
            Un único pago. Abona en la moneda de tu país.
          </p>

          <CtaButton href={PAYMENT_URL} tone="dark" className="mt-5 w-full sm:w-auto md:mt-8" data-id="element-136" data-mp="317rorqi0hcbb">
            Quiero acceder al libro
          </CtaButton>

          <p className="mt-4 text-xs leading-relaxed text-umber/60 md:mt-5" data-id="element-137" data-mp="3f7u4b62ujtne">
            El acceso se habilita de acuerdo con las condiciones de entrega de la
            plataforma de compra.
          </p>
        </div>
      </div>
    </section>;
}